import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {FieldDefinition} from '@shared/models/field-definition';
import {FieldSection} from '@shared/models/field-section';
import {RowClassArgs, SelectableSettings} from '@progress/kendo-angular-grid';
import {takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {TaskAlertRecipientWithStatus, TaskPeopleWithNotificationStatus} from '../../models/task-manager.model';

@Component({
    standalone: false,
    selector: 'particle-task-alert-send-notification-now-grid',
  templateUrl: './task-alert-send-notification-now-grid.component.html',
  styleUrls: ['./task-alert-send-notification-now-grid.component.scss']
})
export class TaskAlertSendNotificationNowGridComponent implements OnInit, OnChanges, OnDestroy {
  recipients$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  @Input() allRecipients$: Observable<TaskAlertRecipientWithStatus[]>;
  @Input() fieldDefinitions$: BehaviorSubject<FieldDefinition[]>;
  @Input() selectedFieldSection$: Observable<FieldSection>;
  @Output() SelectionChanged: EventEmitter<any> = new EventEmitter();
  @Output() ValueChanged: EventEmitter<any> = new EventEmitter();
  @Output() SelectedKeysChange: EventEmitter<any> = new EventEmitter();
  @Input() selectedKeys: string[];
  @Input() selectableSettings: SelectableSettings | boolean = {
    enabled     : true,
    checkboxOnly: true,
    mode        : 'multiple'
  };
  selectBy = 'id';
  unsubscribe$ = new Subject<void>();
  constructor () { }

  ngOnChanges (changes: SimpleChanges): void {
    this.getFields();
  }

  ngOnInit () {
  }

  getFields () {
    this.allRecipients$.pipe(takeUntil(this.unsubscribe$)).subscribe((recipients: TaskAlertRecipientWithStatus[]) => {
      this.recipients$.next(recipients.map(recipient => {
        return {
          cells: {
            Name: {
              value      : recipient.name,
              displayText: recipient.name
            },
            Email : {
              value      : recipient.email,
              displayText: recipient.email
            },
            StatusTooltip : {
              value      : recipient.lastNotificationStatus,
              displayText: recipient.lastNotificationStatus
            }
          },
          id   : recipient.email,
          isDisabled: recipient.isDisable
        };
      }));
    });
  }

  onFieldGridSelectionChanged ($event) {
    this.SelectionChanged.emit($event);
  }

  valueChanged ($event) {
    this.ValueChanged.emit($event);
  }

  onSelectedKeychange (keys: string[]) {
    this.SelectedKeysChange.emit(keys);
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

/*  public rowCallback = (row: RowClassArgs) {
    console.log('row:', row);
    return {
      '''k-disabled': false''
    };
  }*/

public rowCallback (context: RowClassArgs) {
  return context.dataItem.isDisabled === true ? 'avoid-clicks' : '';
}
}
